import React, { useEffect, useState } from "react";
import styles from "./Styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import ModalDescription from "./Modals/ModalDescriptions";
import {
  changeReviewedStatusForFirstVisitAction,
  setCurrentStageSurveyPlanAction,
} from "../Redux/Case-reducer";
import { useNavigate } from "react-router-dom";
import AlertModal from "./Modals/AlertModal";

const HeadInformation = ({ start, setStart }) => {
  const { cover, firstVisitToTheDoctor } = useSelector(
    (state) => state.currentCase
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [infoDescription, setInfoDescription] = useState(null);
  const [isAlert, setIsAlert] = useState(false);
  const setStartFunction = () => {
    setStart(!start);
  };
  const navigateNext = () => {
    let check = true;
    // проверяем все ли окна были открыты и пропускаем дальше
    for (let i = 0; i < firstVisitToTheDoctor.length; i++) {
      if (!firstVisitToTheDoctor[i].isReviewed) check = false;
    }
    if (check) {
      dispatch(setCurrentStageSurveyPlanAction());
      return navigate("survey-plan");
    }
    setIsAlert(true);
    setTimeout(() => {
      setIsAlert(false);
    }, 1500);
  };

  return (
    <section className={styles.containerHeadInf}>
      {!start ? (
        <>
          <div className={styles.patientHeaderInfo}>
            <h2>Общая информация</h2>
            <img src={`${cover.image}`} alt="Изображение пациента" />
            <p>
              Пациент:
              <br />
              мужчина 58 лет, обратился на прием к врачу-урологу.
            </p>
          </div>
          <button onClick={setStartFunction} className="buttonNext">
            Начать лечение
          </button>
        </>
      ) : (
        <>
          {!infoDescription ? (
            <div className={styles.containerHeadInfBegin}>
              <h2>Первый визит к врачу</h2>
              <div className={styles.firstVisitInfo}>
                {firstVisitToTheDoctor.map((block, index) => {
                  return (
                    <section
                      style={{
                        border: block.isReviewed
                          ? "3px solid green"
                          : "1px solid #003d8a",
                      }}
                      className={styles.informationBlock}
                      onClick={() => {
                        dispatch(
                          changeReviewedStatusForFirstVisitAction(index)
                        );
                        setInfoDescription(block);
                      }}
                      key={index}
                    >
                      <img src={`${block.defaultImage}`} alt="" />
                      <div> {block.cardName}</div>
                    </section>
                  );
                })}
              </div>
              <div className={styles.footerButtons}>
                <button onClick={setStartFunction} className="buttonBack">
                  Назад
                </button>
                <button
                  onClick={navigateNext}
                  style={
                    firstVisitToTheDoctor.find((v) => !v.isReviewed)
                      ? { background: "grey" }
                      : {}
                  }
                  className="buttonNext"
                >
                  Далее
                </button>
              </div>
            </div>
          ) : (
            <ModalDescription
              info={infoDescription}
              clouse={setInfoDescription}
            />
          )}
        </>
      )}
      {isAlert && (
        <AlertModal
          info="Осмотр произведен не полностью!"
          setAlertDescription={setIsAlert}
        />
      )}
    </section>
  );
};
export default HeadInformation;
